<!--
 * @Author: your name
 * @Date: 2022-03-12 20:09:48
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-21 09:01:03
 * @Description: file content
-->
<template>
  <div class="lottery-info">
    <van-cell-group title=" ">
      <template>
        <div class="cancel-bottom-border">
          <van-cell center :value="info" value-class="text-center"></van-cell>
        </div>
      </template>
    </van-cell-group>
  </div>
</template>

<script>
  export default {
    props: {
      info: { type: String, default: () => " " },
    },
    // 当 value_alone 为 true 时，values 数组被使用，否则使用 user_infos
  };
</script>

<style lang="less" scoped>
  // 隔行换色
  .cc {
    .van-cell:nth-child(2n-1) {
      background: #fff9f3;
    }
  }
  // 取消 cell 下划线
  .cancel-bottom-border {
    .van-cell::after {
      border-bottom: none;
    }
  }
  // 文本区中
  .text-center {
    text-align: center;
  }
  .lottery-info {
    width: 80%;
    margin: 0 auto;
    .van-cell-group__title {
      color: #000000;
      font-size: 14px;
    }
  }
</style>
